import { FC } from 'react';

import { ImageData } from '.';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  getWatermarkPosition,
  getWatermarkTag,
  withWatermarkDefaults,
} from '../shared';

export const TEXT_POSITIONS = ['bottom', 'top'];
export const DIVIDERS = ['none', 'white', 'black'];
/** Still used by the variations that only offer the actual photo watermark */
export const ACTUAL_PHOTO_VALUES = ['none', 'bottom', 'top'];

export { getWatermarkPosition, getWatermarkTag };

interface Props {
  image: ImageData;
  imageIndex: number;
  type: 'left' | 'right';
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

/**
 * Settings Modal for VariationOne
 * Wraps the shared SettingsModal with variation-specific configuration
 * Supports both left and right image settings
 *
 * Before refactoring: 231 lines
 * After refactoring: 69 lines (70% reduction)
 */
const SettingsModal: FC<Props> = ({ type, image, ...props }) => {
  const typeLabel = type === 'left' ? 'Left' : 'Right';

  return (
    <SharedSettingsModal
      {...props}
      image={withWatermarkDefaults(image)}
      title={`${typeLabel} Image Parameters`}
      sections={[
        ...WATERMARK_SECTIONS,
        {
          title: `${typeLabel} Text Position`,
          type: 'radio',
          stateKey: 'textPosition',
          options: TEXT_POSITIONS,
        },
        {
          title: `Other ${typeLabel} Text Parameters`,
          type: 'checkbox',
          stateKey: '',
          checkboxes: [
            { key: 'quotes', label: 'Quotes' },
            { key: 'brakes', label: 'Custom brakes' },
          ],
        },
        {
          title: 'Cover Divider',
          type: 'radio',
          stateKey: 'divider',
          options: DIVIDERS,
          show: type === 'left',
        },
      ]}
    />
  );
};

export default SettingsModal;
